import { OptionsPillGroup } from "@/components/ui/buttons/OptionsPillGroup";
import { IonSkeletonText } from "@ionic/react";
import { useLifestyleOptions } from "../../hooks/use-lifestyle-options";

interface LifestylePreferenceGroupProps {
  selectedOptions: Set<string>;
  onToggleOption: (option: string) => void;
  disabled?: boolean;
}

export const LifestylePreferenceGroup: React.FC<LifestylePreferenceGroupProps> = ({
  selectedOptions,
  onToggleOption,
  disabled = false,
}) => {
  const { options, isLoading } = useLifestyleOptions();

  if (isLoading) {
    return (
      <div className="flex flex-col gap-4">
        <IonSkeletonText animated className="h-6 w-24 rounded" />
        <div className="flex flex-wrap gap-3">
          {Array.from({ length: 3 }).map((_, i) => (
            <IonSkeletonText key={i} animated className="h-10 w-24 rounded-full" />
          ))}
        </div>
      </div>
    );
  }

  return (
    <OptionsPillGroup
      label="Lifestyle"
      options={options}
      selectedOptions={selectedOptions}
      onToggleOption={onToggleOption}
      disabled={disabled}
    />
  );
};
